/* CuDeToate v3.3 — product gallery controller.
 *
 * The swipe itself is CSS: overflow-x + scroll-snap, driven by the compositor.
 * Nothing here runs per frame while dragging. This file only:
 *   · notes which slide is centred (IntersectionObserver, not a scroll handler)
 *   · moves the track when a thumbnail or arrow is used
 *   · keeps the thumbnail strip, counter and arrow states in sync
 *   · re-points the gallery when the selected variant changes
 *
 * Replaces Flickity on the product page. Flickity is still bundled by the
 * theme for other components; it simply no longer initialises here, because
 * this markup does not emit `.product-gallery__main`.
 */
(function () {
  'use strict';
  if (window.__cdtGallery) return;
  window.__cdtGallery = 1;

  function init(root) {
    if (root.__cdtGal) return;
    root.__cdtGal = 1;

    var track = root.querySelector('[data-cdt-gal-track]');
    if (!track) return;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-cdt-gal-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-cdt-gal-thumb]'));
    var counter = root.querySelector('[data-cdt-gal-count]');
    var prev = root.querySelector('[data-cdt-gal-prev]');
    var next = root.querySelector('[data-cdt-gal-next]');
    var stage = root.querySelector('.cdt-gal__stage');
    if (!slides.length) return;

    var current = 0;

    function setActive(i) {
      if (i === current || i < 0 || i >= slides.length) return;
      current = i;

      for (var s = 0; s < slides.length; s++) slides[s].classList.toggle('is-active', s === i);

      for (var t = 0; t < thumbs.length; t++) {
        var on = t === i;
        thumbs[t].classList.toggle('is-active', on);
        thumbs[t].setAttribute('aria-selected', on ? 'true' : 'false');
      }

      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;

      /* keep the active thumbnail in view without scrolling the page */
      var th = thumbs[i];
      if (th && th.parentNode.scrollWidth > th.parentNode.clientWidth) {
        var p = th.parentNode;
        p.scrollLeft = th.offsetLeft - (p.clientWidth - th.offsetWidth) / 2;
      }

      /* the badge overlay re-measures against the newly centred image */
      if (stage) stage.dispatchEvent(new CustomEvent('cdt-gal:change'));
    }

    function goTo(i) {
      var slide = slides[i];
      if (!slide) return;
      /* Two things this line has to get right:

         1. Distance between slides, not offsetLeft against the track. The stage
            is position:relative, so it is the offsetParent for BOTH the track
            and the slides, and `slide.offsetLeft - track.offsetLeft` came out 0.

         2. Plain assignment, NOT scrollTo({behavior:'smooth'}). An explicit
            smooth scroll fights `scroll-snap-type: x mandatory` — the track
            snapped straight back to 0 and never moved. The track already sets
            `scroll-behavior: smooth` in CSS, so assigning scrollLeft animates
            anyway, and the snap engine is happy with it. */
      track.scrollLeft = slide.offsetLeft - slides[0].offsetLeft;
      setActive(i);
    }

    /* Which slide is centred — an observer rather than a scroll listener, so
       there is no work on the main thread during the swipe itself. */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var best = null;
        for (var k = 0; k < entries.length; k++) {
          if (!entries[k].isIntersecting) continue;
          if (!best || entries[k].intersectionRatio > best.intersectionRatio) best = entries[k];
        }
        if (best) setActive(slides.indexOf(best.target));
      }, { root: track, threshold: [0.55, 0.75, 1] });
      for (var i = 0; i < slides.length; i++) io.observe(slides[i]);
    }

    for (var t2 = 0; t2 < thumbs.length; t2++) {
      (function (btn) {
        btn.addEventListener('click', function () { goTo(+btn.getAttribute('data-index')); });
      })(thumbs[t2]);
    }

    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
    });

    /* Variant sync. The theme used to do this through
       Flickity.data(el).select(i) in assets/utilities.js, which is guarded by
       `if (instance !== undefined)` — with Flickity gone that guard silently
       does nothing, so picking a colour would stop changing the photo with no
       error anywhere. Re-hooked to the same `variant-change` event the
       frequently-bought-together block listens to. */
    function pointAtMedia(mediaId) {
      if (!mediaId) return;
      for (var s = 0; s < slides.length; s++) {
        if (String(slides[s].getAttribute('data-media-id')) === String(mediaId)) { goTo(s); return; }
      }
    }

    var vs = document.querySelector('[data-variant-selection]');
    if (vs) {
      vs.addEventListener('variant-change', function (e) {
        var v = e.detail && e.detail.variant;
        if (v && v.featured_media) pointAtMedia(v.featured_media.id);
      });
    }

    setActive(0);
    slides[0].classList.add('is-active');
    if (prev) prev.disabled = true;
    if (next) next.disabled = slides.length < 2;
  }

  function boot() {
    var roots = document.querySelectorAll('[data-cdt-gal]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
